
import {forwardRef,useRef} from 'react'
import Modal from "@material-ui/core/Modal";
import ContexBox from './contexBox'
import ContexBoxContac from '../contact-info'

export default forwardRef((props, ref) =>  {
    const onRef = useRef(ref);
     const {stateOpen,onModal}=props;
    return (
        <Modal
            ref={onRef}
            aria-describedby="spring-modal-description"
            aria-labelledby="spring-modal-title"
            BackdropProps={{ timeout: 500}}
            className="Modal-from"
            closeAfterTransition
            onClose={() => onModal(false)}
            open={stateOpen}
    >
        <>
        <ContexBox  onModal={onModal} />
        <ContexBoxContac  onModal={onModal} />
        </>
    </Modal>
    )
}
)